import React, { useEffect, useState } from "react";
import Button from './Button'
import logo from '../img/symb.svg'
import { IoFlashSharp } from "react-icons/io5";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Защита от SSR (window недоступен на сервере)
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <header className={`page-header ${isScrolled ? 'scrolled' : 'container'}`}>
      <div className='header-logo'>
        <img src={logo} alt='logo-img'/>
        <span className='logo-text'>Build<span className='logo-text-middle'>the</span>tech</span>
      </div>
      <nav className='header-nav'>
        <ul className='header-tabs'>
          <li><IoFlashSharp className='green'/>Servcies</li>
          <li>Technologies</li>
          <li>Cases</li>
        </ul>
      </nav>
      <div className='header-button'>
        <Button cls='button-secondary' />
      </div>
      <div className='header-burger'>
        <div className='burger-line'></div>
        <div className='burger-line'></div>
      </div>
    </header>
  )
}
